import { Form, Input } from "decorator-form";
import { Entity, Field } from "typegraph";

import CountResult from "common/entities/CountResult";
import InputType from "common/form/InputType";
import IdName from "core/util/IdName";
import entityMeta from "../entityMeta";

@Entity(entityMeta.CATEGORY)
export class ChildCategory {

	@Field()
	public id: any;

	@Field()
	public name: string;

	@Field()
	public sortIndex: number;

	@Field()
	public iconUrl: string;
}

@Entity(entityMeta.ARTICLE)
export class Article {

	@Field()
	public id: any;

	@Field()
	public name: string;

	@Field()
	public displayName: string;

	@Field()
	public title: string;

	@Field()
	public iconUrl: string;

	@Field()
	public sortIndex: number;

}

@Entity(entityMeta.CATEGORY)
@Form()
export class Category<T = any> {

	@Field()
	public id: any;

	@Field()
	public guid?: string;

	@Field()
	@Input({
		type: InputType.TEXT,
		title: "Name",
		required: true
	})
	public name: string;

	@Field()
	@Input({
		type: InputType.TEXT,
		title: "External ID (optional)",
		description: "Used for identifying this category from external systems."
	})
	public externalId?: string;

	@Field()
	@Input({
		type: InputType.TEXT_HTML,
		title: "Description"
	})
	public description?: string;

	@Field()
	public iconUrl?: null | string;

	@Field()
	@Input({type: InputType.NUMBER_POSITIVE, title: "Sort Index"})
	public sortIndex: number;

	@Input({
		type: InputType.UPLOAD_URL_IMAGE,
		title: "Icon"
	})
	public tempIconUrl?: string;

	@Field()
	@Input({
		type: InputType.CHECKBOX,
		title: "Published",
		description: "If checked, this category will show to non-author users."
	})
	public published?: boolean;

	@Field()
	public uiSchema?: T;

	@Field({entity: CountResult})
	public articleCount?: CountResult;

	@Field({entity: CountResult})
	public childrenCount?: CountResult;

	@Field({entity: IdName})
	public knowledgeBase?: IdName;

}



// WEBPACK FOOTER //
// ./src/panels/kb/category/entities.ts